<template>
  <section class="character_upgrade">
    <div class="container-fluid">
      <div class="character_upgrade_main">
        <div class="left_menu_tab">
          <div class="left_menu_tab_title">
            <img src="../assets/images/character-upgrade-title.png" alt="" />
          </div>
          <ul class="vertical dropdown menu" data-dropdown-menu>
            <li
              v-for="upgrade in upgrades"
              :key="upgrade.id"
              :class="
                upgrade.comingSoon ||
                !upgrade.isCharacterSubscribed ||
                !upgrade.isPowerUp
                  ? 'comming_soon'
                  : 'is-dropdown-submenu-parent opens-right'
              "
            >
              <a href="#">
                <img :src="upgrade.img" alt="" />
                <span>
                  {{ upgrade.title }}
                  <b v-if="upgrade.comingSoon">Coming Soon</b>
                  <b
                    v-if="!upgrade.comingSoon && !upgrade.isCharacterSubscribed"
                  >
                    No Character
                  </b>
                  <b
                    v-if="
                      !upgrade.comingSoon &&
                      upgrade.isCharacterSubscribed &&
                      !upgrade.isPowerUp
                    "
                  >
                    No Upgrade
                  </b>
                </span>
              </a>
              <ul
                class="menu inner_drop"
                style="position: absolute; left: 100%; top: 0"
                v-if="
                  !upgrade.comingSoon &&
                  upgrade.isCharacterSubscribed &&
                  upgrade.isPowerUp
                "
                :class="{ power: !upgrade.isCharacter }"
              >
                <article class="row" v-if="upgrade.isCharacter">
                  <aside
                    class="col-md-4"
                    v-for="(item, index) in upgrade.items"
                    :key="index"
                  >
                    <a @click.prevent="selectCharacter(item)"
                      ><img :src="item.img" alt=""
                    /></a>
                  </aside>
                </article>
                <article class="row" v-if="!upgrade.isCharacter">
                  <aside class="col-md-12">
                    <!--  -->
                    <div class="power_upgrade_inner">
                      <div class="power_upgrade_range">
                        <span
                          class="remove_power"
                          @click.prevent="deceaseAttributeValue(upgrade)"
                        >
                          <i class="fa fa-minus"></i>
                        </span>

                        <ul style="line-height: 21px !important">
                          <li
                            v-for="i in upgrade.maxValue"
                            :key="i"
                            style="border: none; margin: 0px"
                            :class="{ active: i <= upgrade.currentValue }"
                          ></li>
                        </ul>
                        <span
                          class="add_power"
                          @click.prevent="increaseAttributeValue(upgrade)"
                        >
                          <i class="fa fa-plus"></i>
                        </span>
                      </div>
                    </div>
                  </aside>
                  <aside>
                    <a
                      @click.prevent="
                        upgradeAttributes(upgrade, currentCharacter.id)
                      "
                    >
                      <img
                        src="../assets/images/upgrade_orange.png"
                        alt=""
                        class="orange"
                      />
                    </a>
                  </aside>
                </article>
              </ul>
            </li>
          </ul>
        </div>
        <div class="character_img_up">
          <img
            v-if="currentCharacter && currentCharacter.mainImage"
            :src="currentCharacter.mainImage"
            alt=""
          />
        </div>
        <div
          class="power_upgrade"
          v-if="
            currentCharacter &&
            currentCharacter.powerUpgrades &&
            currentCharacter.powerUpgrades.length > 0
          "
        >
          <article class="row">
            <aside class="col-md-12">
              <div
                class="power_upgrade_inner"
                v-for="item in getPowerUpgradeList().slice(0, 3)"
                :key="item.id"
              >
                <h4>
                  {{ item.title }}
                  <i
                    class="fa fa-info-circle"
                    v-tooltip="getBalanceOf(item) + ' per level'"
                    v-if="item.isPowerUp"
                  ></i>
                </h4>
                <div class="power_upgrade_range">
                  <span
                    :class="
                      item.isPowerUp
                        ? 'remove_power power_dec'
                        : 'remove_power power_dec_disabled'
                    "
                    @click.prevent="deceaseAttributeValue(item)"
                  >
                    <i class="fa fa-minus-circle"></i>
                  </span>
                  <ul>
                    <li
                      v-for="i in item.maxValue"
                      :key="i"
                      :class="{
                        active: i <= item.currentValue,
                        added: (item.actualValue < i && item.currentValue >= i),
                      }"
                    ></li>
                  </ul>
                  <span
                    :class="
                      item.isPowerUp
                        ? 'add_power power_inc'
                        : 'add_power power_inc_disabled'
                    "
                    @click.prevent="increaseAttributeValue(item)"
                  >
                    <i class="fa fa-plus-circle"></i>
                  </span>
                  <span>{{ item.actualValue }}</span>
                </div>
              </div>
            </aside>
            <aside class="col-md-12">
              <div
                class="power_upgrade_inner"
                v-for="item in getPowerUpgradeList().slice(3, 6)"
                :key="item.id"
              >
                <h4>
                  {{ item.title }}
                  <i
                    class="fa fa-info-circle"
                    v-tooltip="getBalanceOf(item) + ' per level'"
                    v-if="item.isPowerUp"
                  ></i>
                </h4>
                <div class="power_upgrade_range">
                  <span
                    class="remove_power"
                    :class="
                      item.isPowerUp
                        ? 'remove_power power_dec'
                        : 'remove_power power_dec_disabled'
                    "
                    @click.prevent="deceaseAttributeValue(item)"
                  >
                    <i class="fa fa-minus-circle"></i>
                  </span>
                  <ul>
                    <li
                      v-for="i in item.maxValue"
                      :key="i"
                      :class="{
                        active: i <= item.currentValue,
                        added: (item.actualValue < i && item.currentValue >= i),
                      }"
                    ></li>
                  </ul>
                  <span
                    :class="
                      item.isPowerUp
                        ? 'add_power power_inc'
                        : 'add_power power_inc_disabled'
                    "
                    @click.prevent="increaseAttributeValue(item)"
                  >
                    <i class="fa fa-plus-circle"></i>
                  </span>
                  <span>{{ item.actualValue }}</span>
                </div>
              </div>
            </aside>
            <aside class="col-md-12" v-if="isAnyUpgradeChanged()">
              <a @click.prevent="batchUpgradeAttributes()">
                <img
                  src="../assets/images/upgrade_orange.png"
                  alt=""
                  class="orange"
                  style="height: 25px"
                />
              </a>
            </aside>
          </article>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import ApiService from "@/services/ApiService";

export default {
  name: "Character",
  computed: {
    ...mapGetters(["account", "chain"]),
  },
  data() {
    return {
      currentCharacter: null,
      upgrades: [
        {
          id: 1,
          title: "MY characterS",
          comingSoon: false,
          isCharacterSubscribed: false,
          isCharacter: true,
          img: require("../assets/images/icon-d1.png"),
          items: [],
          isPowerUp: true,
        },
        {
          id: 2,
          title: "SKINS upgrade",
          comingSoon: true,
          isCharacterSubscribed: false,
          img: require("../assets/images/icon-d2.png"),
          items: [],
          actualValue: 0,
          currentValue: 0,
          maxValue: 0,
          price: {
            Common: 0,
            Rare: 0,
            Legendary: 0,
            Epic: 0,
          },
          isPowerUp: false,
        },
        {
          id: 3,
          title: "POWER upgrade",
          comingSoon: false,
          isCharacterSubscribed: false,
          img: require("../assets/images/icon-d3.png"),
          items: [],
          actualValue: 0,
          currentValue: 0,
          maxValue: 0,
          price: {
            Common: 0.01,
            Rare: 0.02,
            Legendary: 0.04,
            Epic: 0.1,
          },
          isPowerUp: true,
        },
        {
          id: 4,
          title: "Health upgrade",
          comingSoon: false,
          isCharacterSubscribed: false,
          img: require("../assets/images/icon-d4.png"),
          items: [],
          actualValue: 0,
          currentValue: 0,
          maxValue: 0,
          price: {
            Common: 0.01,
            Rare: 0.02,
            Legendary: 0.04,
            Epic: 0.1,
          },
          isPowerUp: true,
        },
        {
          id: 5,
          title: "Mobility upgrade",
          comingSoon: false,
          isCharacterSubscribed: false,
          img: require("../assets/images/icon-d5.png"),
          items: [],
          actualValue: 0,
          currentValue: 0,
          maxValue: 0,
          price: {
            Common: 0,
            Rare: 0,
            Legendary: 0,
            Epic: 0,
          },
          isPowerUp: false,
        },
        {
          id: 6,
          title: "Techniques upgrade",
          comingSoon: false,
          isCharacterSubscribed: false,
          img: require("../assets/images/icon-d6.png"),
          items: [],
          actualValue: 0,
          currentValue: 0,
          maxValue: 0,
          price: {
            Common: 0,
            Rare: 0,
            Legendary: 0,
            Epic: 0,
          },
          isPowerUp: false,
        },
        {
          id: 7,
          title: "Range upgrade",
          comingSoon: false,
          isCharacterSubscribed: false,
          img: require("../assets/images/icon-d7.png"),
          items: [],
          actualValue: 0,
          currentValue: 0,
          maxValue: 0,
          price: {
            Common: 0,
            Rare: 0,
            Legendary: 0,
            Epic: 0,
          },
          isPowerUp: false,
        },
        {
          id: 8,
          title: "Speed upgrade",
          comingSoon: false,
          isCharacterSubscribed: false,
          img: require("../assets/images/icon-d8.png"),
          items: [],
          actualValue: 0,
          currentValue: 0,
          maxValue: 0,
          price: {
            Common: 0.01,
            Rare: 0.02,
            Legendary: 0.04,
            Epic: 0.1,
          },
          isPowerUp: true,
        },
      ],
      powerUpgrades: [
        {
          id: 1,
          value: 6,
          title: "POWER UPGRADE",
        },
        {
          id: 2,
          value: 7,
          title: "HEALTH UPGRADE",
        },
        {
          id: 3,
          value: 5,
          title: "HEALTH UPGRADE",
        },
        {
          id: 4,
          value: 5,
          title: "TECHNIQUES UPGRADE",
        },
        {
          id: 5,
          value: 6,
          title: "RANGE UPGRADE",
        },
        {
          id: 6,
          value: 9,
          title: "SPEED UPGRADE",
        },
      ],
    };
  },
  mounted() {
    // $('.dropdown').dropdown();
    console.log("HELLO" + this.$store.state.characterTypeId);
    if (this.$store.state.characterTypeId) {
      this.getTokens();
    }
  },
  methods: {
    async getTokens() {
      this.tokens = await ApiService.getAccountTokens(
        this.chain.chainId,
        this.account
      );
      if (this.tokens && this.tokens.length != 0) {
        console.log("YES");
        for (let list of this.upgrades) {
          list.isCharacterSubscribed = true;
          if (list && list.isCharacter) {
            let selectedCharacter = null;
            for (let obj of this.tokens) {
              let powerUpgrades = [];
              let rarity = null;
              for (let power of obj.attributes) {
                if (power.trait_type == "power") {
                  powerUpgrades.push({
                    id: 1,
                    value: power.value,
                    max_value: power.max_value,
                    title: "POWER UPGRADE",
                    trait_type: "power",
                  });
                } else if (power.trait_type == "health") {
                  powerUpgrades.push({
                    id: 2,
                    value: power.value,
                    max_value: power.max_value,
                    title: "HEALTH UPGRADE",
                    trait_type: "health",
                  });
                } else if (power.trait_type == "mobility") {
                  powerUpgrades.push({
                    id: 3,
                    value: power.value,
                    max_value: power.max_value,
                    title: "MOBILITY UPGRADE",
                    trait_type: "mobility",
                  });
                } else if (power.trait_type == "techniques") {
                  powerUpgrades.push({
                    id: 4,
                    value: power.value,
                    max_value: power.max_value,
                    title: "TECHNIQUES UPGRADE",
                    trait_type: "techniques",
                  });
                } else if (power.trait_type == "range") {
                  powerUpgrades.push({
                    id: 5,
                    value: power.value,
                    max_value: power.max_value,
                    title: "RANGE UPGRADE",
                    trait_type: "range",
                  });
                } else if (power.trait_type == "speed") {
                  powerUpgrades.push({
                    id: 6,
                    value: power.value,
                    max_value: power.max_value,
                    title: "SPEED UPGRADE",
                    trait_type: "speed",
                  });
                } else if (power.trait_type == "Rarity") {
                  rarity = power.value;
                }
              }

              let image = require("../assets/images/frame-lock.png");
              let mainImage = null;
              if (obj.name == "Sho Yukara") {
                image = require("../assets/images/c1.png");
                mainImage = require("../assets/images/Sho Yakura.png");
              } else if (obj.name == "Subject 172") {
                image = require("../assets/images/c2.png");
                mainImage = require("../assets/images/Subject 172.png");
              } else if (obj.name == "Chuck") {
                image = require("../assets/images/c3.png");
                mainImage = require("../assets/images/Chuck.png");
              } else if (obj.name == "Spikerock") {
                image = require("../assets/images/c4.png");
                mainImage = require("../assets/images/Spike Rock.png");
              } else if (obj.name == "Jun Seku") {
                image = require("../assets/images/c5.png");
                mainImage = require("../assets/images/Jen Seku.png");
              } else if (obj.name == "Bundy") {
                image = require("../assets/images/c6.png");
                mainImage = require("../assets/images/Bundy.png");
              } else if (obj.name == "Marley") {
                image = require("../assets/images/c7.png");
                mainImage = require("../assets/images/Marley.png");
              } else if (obj.name == "Javier") {
                image = require("../assets/images/c8.png");
                mainImage = require("../assets/images/Javier.png");
              } else if (obj.name == "Hosokawa") {
                image = require("../assets/images/c9.png");
                mainImage = require("../assets/images/Hosokawa.png");
              } else if (obj.name == "Tyr") {
                image = require("../assets/images/c10.png");
                mainImage = require("../assets/images/TYR.png");
              } else if (obj.name == "Malak al Mawt") {
                image = require("../assets/images/c11.png");
                mainImage = require("../assets/images/Malak Al Mawt.png");
              } else if (obj.name == "Hanatar") {
                image = require("../assets/images/c12.png");
                mainImage = require("../assets/images/Hanatar.png");
              } else if (obj.name == "Omen") {
                image = require("../assets/images/c13.png");
                mainImage = require("../assets/images/Omen.png");
              }

              let character = {
                img: image,
                mainImage: mainImage,
                id: obj.tokenId,
                name: obj.name,
                rarity: rarity,
                powerUpgrades: powerUpgrades,
              };
              console.log(character);
              list.items.push(character);
              if (this.$store.state.characterTypeId == character.id) {
                selectedCharacter = character;
              }
            }
            if (selectedCharacter) {
              this.selectCharacter(selectedCharacter);
            } else {
              this.selectCharacter(list.items[0]);
            }
          }
        }
        // this.currentCharacter =
      } else {
        console.log("ELSE");
        //If setting required for no Character
      }
      // this.loading = false;
    },
    selectCharacter(character) {
      this.currentCharacter = character;

      for (let obj of this.upgrades) {
        for (let power of this.currentCharacter.powerUpgrades) {
          if (power.trait_type == "power" && obj.id == 3) {
            obj.actualValue = power.value;
            obj.currentValue = power.value;
            obj.maxValue = power.max_value;
          } else if (power.trait_type == "health" && obj.id == 4) {
            obj.actualValue = power.value;
            obj.currentValue = power.value;
            obj.maxValue = power.max_value;
          } else if (power.trait_type == "mobility" && obj.id == 5) {
            obj.actualValue = power.value;
            obj.currentValue = power.value;
            obj.maxValue = power.max_value;
          } else if (power.trait_type == "techniques" && obj.id == 6) {
            obj.actualValue = power.value;
            obj.currentValue = power.value;
            obj.maxValue = power.max_value;
          } else if (power.trait_type == "range" && obj.id == 7) {
            obj.actualValue = power.value;
            obj.currentValue = power.value;
            obj.maxValue = power.max_value;
          } else if (power.trait_type == "speed" && obj.id == 8) {
            obj.actualValue = power.value;
            obj.currentValue = power.value;
            obj.maxValue = power.max_value;
          }
        }
      }
    },
    async upgradeAttributes(upgrade, tokenId) {
      console.log("Upgrade of ::" + JSON.stringify(upgrade));
      if (upgrade && upgrade.actualValue != upgrade.currentValue) {
        let diff = upgrade.currentValue - upgrade.actualValue;
        console.log("YES:::" + upgrade.id);
        let upgradeObj = {
          upgradePoints: diff,
          upgradeTypeId: upgrade.id,
          tokenId: tokenId,
        };
        const tx = await this.$store.dispatch("upgradeAttributes", upgradeObj);
        console.log(tx);
        if (tx) {
          upgrade.actualValue = 0 + upgrade.currentValue;
        }
      }
    },

    batchUpgradeAttributes() {
      let upgradeObjList = [];
      for (let upgrade of this.upgrades) {
        if (upgrade.actualValue != upgrade.currentValue) {
          console.log("Upgrade batch::");
          let diff = upgrade.currentValue - upgrade.actualValue;
          let upgradeObj = {
            upgradePoints: diff,
            upgradeTypeId: upgrade.id,
            tokenId: this.currentCharacter.id,
          };
          upgradeObjList.push(upgradeObj);
        }
      }
      if (upgradeObjList.length > 0) {
        console.log("CALLL ABI Batch Upgrade");
      }
    },

    isAnyUpgradeChanged() {
      let isChanged = false;
      for (let upgrade of this.upgrades) {
        if (upgrade.isPowerUp && upgrade.actualValue != upgrade.currentValue) {
          return true;
        }
      }
      return isChanged;
    },

    getCurrentPoints(item) {
      console.log(item);
    },

    increaseAttributeValue(upgrade) {
      if (upgrade.isPowerUp && upgrade.actualValue + 2 > upgrade.currentValue) {
        upgrade.currentValue = upgrade.currentValue + 1;
      }
    },

    deceaseAttributeValue(upgrade) {
      if (
        upgrade.isPowerUp &&
        upgrade.actualValue != upgrade.currentValue &&
        upgrade.actualValue < upgrade.currentValue + 2
      ) {
        upgrade.currentValue = upgrade.currentValue - 1;
      }
    },

    getPowerUpgradeList() {
      let list = [];
      for (let upgrade of this.upgrades) {
        if (upgrade.id > 2) {
          list.push(upgrade);
        }
      }
      return list;
    },

    getBalanceOf(upgrade) {
      if (this.currentCharacter.rarity && upgrade.price) {
        return upgrade.price[this.currentCharacter.rarity];
      }
      return "";
    },
  },
  watch: {
    account(newVal) {
      console.log("WATCH::::0");
      if (newVal) {
        console.log("WATCH::::1");
        this.getTokens();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@media (min-width: 769px) {
  .opens-right {
    .menu {
      display: none;
      z-index: 11;

      &:hover {
        display: block;
      }
    }

    & > a:hover {
      & + .menu {
        display: block;
      }
    }
  }
}

@media (max-width: 768px) {
  .opens-right {
    .menu {
      position: static !important;
      width: 100% !important;
      display: none;
      z-index: 11;
      padding: 15px 0;

      &:hover {
        display: block;
      }
    }

    & > a:hover {
      & + .menu {
        display: block;
      }
    }
  }
}
</style>
